import type { FC } from 'react'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'

import './banner.scss'

const Banner: FC = () => {
  const { whiteLabel } = useAppContext()

  return (
    <div className={`site-banner wl-${whiteLabel}`}>
      <h1>
        <Translation id="Dealer" />
      </h1>
    </div>
  )
}

export default Banner
